import angular from 'angular';

import '../../core/main/filter/country_terms_url/filter';
import '../../core/main/filter/country_privacy_url/filter';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.module.footer", [
]).controller("merchant.application.module.footer.controller", [
    "$scope", "$controller",
    "core.application.main.controller.environment",
    "merchant.application.main.factory.authentication",
    "core.application.main.factory.country",
    function($scope, $controller, Environment, Authentication, Country) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        $scope.model.copyrightYear = new Date().getFullYear();

        $scope.merchantId = function() {
            return Authentication.merchantId();
        };

        $scope.countryCode = Authentication.countryCode() || Country.getCountryCodeFromUrl();
    }
]);
